<template>
  <div class="box meal-add">
    <h3 class="title">{{ $t("What would you like to cook next week?") }}</h3>
    <RecipeList
      :recipes="recipes"
      :primaryActionLabel="$t('Select')"
      @primaryActionSelected="recipeSelected"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { Meal } from "@/models/Meal.ts";
import RecipeList from "@/components/RecipeList";

export default Vue.extend({
  name: "MealAdd",
  components: { RecipeList },
  props: {
    recipes: Array,
  },
  methods: {
    recipeSelected(recipe) {
      this.$store.dispatch("addMeal", new Meal(recipe));
    },
  },
});
</script>

<style scoped></style>
<i18n>
{
  "en": {},
  "de": {
    "Add meal": "Mahlzeit hinzufügen",
    "What would you like to cook next week?": "Was möchtest du nächste Woche kochen?"
  }
}
</i18n>
